import React from 'react'

import ChatButton from './Button'
import ChatComponent from './Component'
import { Container } from './styles'

import { useChatContext } from '../context'

const Index = () => {
    const { isChatOpen, toggleChat, unreadCount } = useChatContext()
    const chatBtnProps = {
        isChatOpen,
        toggleChat,
        unreadCount,
    }
    return (
        <Container>
            <ChatButton {...chatBtnProps} />
            <ChatComponent close={toggleChat} isChatOpen={isChatOpen} />
        </Container>
    )
}

export default Index
